import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import BarGraph from "../../../general/BarGraph";
import SmallPieGraph from "../../../general/SmallPieGraph";
import BigCard from "../../../general/BigCard";
import styles from "./HealthL2.module.css";
import HealthMap from "./maps/HealthMap";

function HealthL2({ distrito, healthValues, setHealthProperties2 }) {
  const {
    frequenciaExameValue,
    atendimentoAmbulanciaValue,
    sistemaSaudeValue,
    usoMedicamentoValue,
    dificuldadeAtendimentoValue,
    qualidadeSSMunicipalValue,
    qualidadeSSRuralValue,
    possuiDoencaCronicaValue,
    tipoDoencaCronicaValue,
    programaSaudeRuralValue,
  } = healthValues;

  const {
    setUsoMedicamentoValue,
    setDificuldadeAtendimentoValue,
    setQualidadeSSMunicipalValue,
    setQualidadeSSRuralValue,
    setUsoMedicamentoImage,
    setDificuldadeAtendimentoImage,
    setQualidadeSSMunicipalImage,
    setQualidadeSSRuralImage,
  } = setHealthProperties2;

  const [numeroPropriedades, setNumeroPropriedades] = useState(null);
  const [usoMedicamento, setUsoMedicamento] = useState(null);
  const [dificuldadeAtendimento, setDificuldadeAtendimento] = useState(null);
  const [qualidadeSSMunicipal, setQualidadeSSMunicipal] = useState(null);
  const [qualidadeSSRural, setQualidadeSSRural] = useState(null);
  const [usoMedicamentoOldValue, setUsoMedicamentoOldValue] = useState(null);
  const [dificuldadeAtendimentoOldValue, setDificuldadeAtendimentoOldValue] =
    useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [
          usoMedicamento,
          dificuldadeAtendimento,
          qualidadeSSMunicipal,
          qualidadeSSRural,
          numeroPropriedades,
        ] = await Promise.all([
          Api.getUsoMedicamento(distrito),
          Api.getDificuldadeAtendimento(distrito),
          Api.getQualidadeSSMunicipal(distrito),
          Api.getQualidadeSSRural(distrito),
          Api.getNumeroPropriedades2(
            distrito,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null
          ),
        ]);

        setUsoMedicamento(Functions.buildSmallPieGraphParams(usoMedicamento));
        setDificuldadeAtendimento(
          Functions.buildSmallPieGraphParams(dificuldadeAtendimento)
        );
        setQualidadeSSMunicipal(Functions.buildBarGraph(qualidadeSSMunicipal));
        setQualidadeSSRural(Functions.buildBarGraph(qualidadeSSRural));
        setNumeroPropriedades(numeroPropriedades);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [distrito]);

  if (loading) return <div className={styles.healthL2}></div>;

  const onUsoMedicamentoOldValue = (value) => {
    setUsoMedicamentoOldValue(value);
  };

  const onDificuldadeAtendimentoOldValue = (value) => {
    setDificuldadeAtendimentoOldValue(value);
  };

  const onUsoMedicamentoClick = (value) => {
    setUsoMedicamentoValue(value);
  };

  const onDificuldadeAtendimentoClick = (value) => {
    setDificuldadeAtendimentoValue(value);
  };

  return (
    <div className={styles.healthL2}>
      <div className={styles.firstPart}>
        <div className={styles.mapCards}>
          <div className={styles.cards}>
            <div className={styles.bigCard}>
              <BigCard
                name="Propriedades"
                value={numeroPropriedades?.value ?? "..."}
              />
            </div>
          </div>

          <div className={styles.map}>
            <HealthMap distrito={distrito} />
          </div>
        </div>
        <div className={styles.healthGraphs}>
          {usoMedicamento && (
            <div className={styles.smallPiegraph}>
              <SmallPieGraph
                data={usoMedicamento}
                text="USO DE MEDICAMENTOS"
                onLegendClick={onUsoMedicamentoClick}
                currentValue={usoMedicamentoValue}
                oldValue={usoMedicamentoOldValue}
                onOldValue={onUsoMedicamentoOldValue}
                onImageReady={setUsoMedicamentoImage}
              />
            </div>
          )}
          {dificuldadeAtendimento && (
            <div className={styles.smallPiegraph}>
              <SmallPieGraph
                data={dificuldadeAtendimento}
                text="DIFICULDADE DE ATENDIMENTO"
                onLegendClick={onDificuldadeAtendimentoClick}
                currentValue={dificuldadeAtendimentoValue}
                oldValue={dificuldadeAtendimentoOldValue}
                onOldValue={onDificuldadeAtendimentoOldValue}
                onImageReady={setDificuldadeAtendimentoImage}
              />
            </div>
          )}
        </div>
      </div>

      <div className={styles.barGraph}>
        {qualidadeSSMunicipal && (
          <div className={styles.graph}>
            <BarGraph
              data={qualidadeSSMunicipal}
              text="QUALIDADE DO SISTEMA DE SAÚDE MUNICIPAL"
              onImageReady={setQualidadeSSMunicipalImage}
            />
          </div>
        )}
        {qualidadeSSRural && (
          <div className={styles.graph}>
            <BarGraph
              data={qualidadeSSRural}
              text="QUALIDADE DO SISTEMA DE SAÚDE RURAL"
              onImageReady={setQualidadeSSRuralImage}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default HealthL2;
